/**
 * Extracts the first path segment from a pathname.
 * e.g., '/tasks/123' → 'tasks', '/scheduler' → 'scheduler', '/' → ''
 */
export function getRouteSegment(pathname: string): string {
  return pathname.split('/').filter(Boolean)[0] || '';
}
